import React from 'react';
import AnswerCard from './AnswerCard';
import EvidenceTable from './EvidenceTable';
import TrailList from './TrailList';
import { stateBanners, isLegacyTurn } from '../../utils/askScope';

const list = (v) => (Array.isArray(v) ? v.filter((s) => typeof s === 'string' && s) : []);

// One question and its response, in the order: state banners, direct answer, evidence, next
// steps, trail (collapsed when finished), follow-up chips. Props only; AgentPanel wires the
// callbacks (Task 15). `onJump(rowRef)`, `onAsk(text)`, `onRetry(questionText)`,
// `isRowLive(rowRef)`, `busy` (a turn is working: follow-ups disabled).
export default function AskTurn({ turn, onJump, onAsk, onRetry, isRowLive, busy, renderExtra }) {
  const t = turn && typeof turn === 'object' ? turn : {};
  const working = t.status === 'working';
  const banners = stateBanners(t);
  const legacy = isLegacyTurn(t);
  const body = legacy ? t.markdown : t.answer;
  const next = list(t.next);
  const followUps = list(t.followUps);
  const capHit = t.status === 'capHit' || (t.usage && t.usage.capHit === true);

  return (
    <article className="ask-turn" data-status={t.status || ''}>
      {t.question ? <div className="ask-q">{t.question}</div> : null}
      {banners.map((b, i) => (
        <div key={i} className={`ask-banner ask-banner--${b.kind}`} role={b.role}>
          <span>{b.text}</span>
          {b.kind === 'error' && typeof onRetry === 'function' ? (
            <button type="button" className="ask-btn" onClick={() => onRetry(t.question)}>Retry</button>
          ) : null}
        </div>
      ))}
      {working ? <div className="ask-working"><span className="ask-dot" aria-hidden="true" />Investigating</div> : null}
      {body ? <AnswerCard text={body} usage={t.usage} capHit={capHit} /> : null}
      {typeof renderExtra === 'function' ? renderExtra(t) : null}
      <EvidenceTable evidence={t.evidence} onJump={onJump} isRowLive={isRowLive} />
      {next.length ? (
        <div className="ask-next">
          <div className="ask-section-label">Check next</div>
          <ol>{next.map((n, i) => <li key={i}>{n}</li>)}</ol>
        </div>
      ) : null}
      <TrailList trail={t.trail} working={working} />
      {followUps.length ? (
        <div className="ask-followups">
          {followUps.map((f, i) => (
            <button key={i} type="button" className="ask-followup" disabled={!!busy} onClick={() => onAsk && onAsk(f)}>{f}</button>
          ))}
        </div>
      ) : null}
    </article>
  );
}
